<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card">
                <app-empty-content [isVisible]="!hasProfessionalData(data)"
                    title="Nenhum dado profissional encontrado"
                    description="Não foi encontrado nenhum dado profissional nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">

                </app-empty-content>

                <ng-container *ngIf="hasProfessionalData(data)">
                    <div class="dash-details-card-header">
                        <span>Dados da entidade</span>
                    </div>

                    <app-spacer [bottom]="15"></app-spacer>

                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CNPJ
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.document_number
                                        ?
                                        formatCnpj(data.document_number)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-8">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        RAZÃO SOCIAL
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.corporate_name
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        OCUPAÇÃO PROFISSIONAL
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.occupation
                                        ?
                                        data.occupation :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        E-MAIL CORPORATIVO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.corporate_email
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Celular
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.phone && (data.phone.number ||
                                        data.phone.phone)
                                        ?
                                        formatPhone(data.phone)
                                        :'--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        RAMAL
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.phone?.branch
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container *ngIf="data.address">
                                <div class="col-12 col-md-4">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            CEP
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{data.address?.cep
                                            ?? '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12 col-md-8">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            ENDEREÇO COMPLETO
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{formatAddress(data.address)}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização de comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Versão Principal (Main) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('main')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('main')">
                <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>

                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <div class="dash-details-card">
                        <app-empty-content [isVisible]="!hasProfessionalData(getDataForView('main'))"
                            title="Nenhum dado profissional encontrado"
                            description="Não foi encontrado nenhum dado profissional nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <ng-container *ngIf="hasProfessionalData(getDataForView('main'))">
                            <ng-template #versionTemplate let-data="data"
                                let-versionType="versionType">
                                <div class="dash-details-card-header">
                                    <span>Dados da entidade</span>
                                </div>

                                <app-spacer [bottom]="15"></app-spacer>

                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    CNPJ
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.document_number
                                                    ?
                                                    formatCnpj(data.document_number)
                                                    : '--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-8">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    RAZÃO SOCIAL
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.corporate_name
                                                    ?? '--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    OCUPAÇÃO PROFISSIONAL
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.occupation
                                                    ?
                                                    data.occupation :
                                                    '--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    E-MAIL CORPORATIVO
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.corporate_email
                                                    ?? '--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Celular
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.phone &&
                                                    (data.phone.number ||
                                                    data.phone.phone)
                                                    ?
                                                    formatPhone(data.phone)
                                                    :'--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    RAMAL
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{data.phone?.branch
                                                    ??
                                                    '--'}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <ng-container *ngIf="data.address">
                                            <div class="col-12 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        CEP
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{data.address?.cep
                                                        ?? '--'}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        COMPLEMENTO
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{data.address?.complement
                                                        ?? '--'}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-8">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        ENDEREÇO COMPLETO
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{formatAddress(data.address)}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>

                            <ng-container
                                *ngTemplateOutlet="versionTemplate; context: { data: getDataForView('main'), versionType: 'main' }"></ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <!-- Versão Comparando (Comparing) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('comparing')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('comparing')">
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>

                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <div class="dash-details-card">
                        <app-empty-content
                            [isVisible]="!hasProfessionalData(getDataForView('comparing'))"
                            title="Nenhum dado profissional encontrado"
                            description="Não foi encontrado nenhum dado profissional nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <ng-container *ngIf="hasProfessionalData(getDataForView('comparing'))">
                            <ng-template #versionTemplateComparing
                                let-data="data" let-versionType="versionType">
                                <div class="dash-details-card-header">
                                    <span>Dados da entidade</span>
                                </div>

                                <app-spacer [bottom]="15"></app-spacer>

                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getFieldComparisonIcon('document_number', versionType)"></span>
                                                    <span>CNPJ</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getFieldStrikethroughClass('document_number', versionType)">{{getFieldValueForDisplay('document_number',
                                                    data.document_number,
                                                    versionType)
                                                    ?
                                                    formatCnpj(getFieldValueForDisplay('document_number',
                                                    data.document_number,
                                                    versionType))
                                                    : '--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-8">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getFieldComparisonIcon('corporate_name', versionType)"></span>
                                                    <span>Razão social</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getFieldStrikethroughClass('corporate_name', versionType)">{{getFieldValueForDisplay('corporate_name',
                                                    data.corporate_name,
                                                    versionType)
                                                    ?? '--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getFieldComparisonIcon('occupation', versionType)"></span>
                                                    <span>OCUPAÇÃO
                                                        PROFISSIONAL</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getFieldStrikethroughClass('occupation', versionType)">{{getFieldValueForDisplay('occupation',
                                                    data.occupation,
                                                    versionType)
                                                    ?
                                                    getFieldValueForDisplay('occupation',
                                                    data.occupation,
                                                    versionType) :
                                                    '--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getFieldComparisonIcon('corporate_email', versionType)"></span>
                                                    <span>E-MAIL
                                                        CORPORATIVO</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getFieldStrikethroughClass('corporate_email', versionType)">{{getFieldValueForDisplay('corporate_email',
                                                    data.corporate_email,
                                                    versionType)
                                                    ?? '--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getPhoneComparisonIcon(versionType)"></span>
                                                    <span>Celular</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getPhoneStrikethroughClass(versionType)">{{getPhoneValueForDisplay(data.phone,
                                                    versionType) &&
                                                    (getPhoneValueForDisplay(data.phone,
                                                    versionType).number ||
                                                    getPhoneValueForDisplay(data.phone,
                                                    versionType).phone)
                                                    ?
                                                    formatPhone(getPhoneValueForDisplay(data.phone,
                                                    versionType))
                                                    :'--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle"
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <span
                                                        [innerHTML]="getFieldComparisonIcon('phone.branch', versionType)"></span>
                                                    <span>RAMAL</span>
                                                </span>

                                                <span
                                                    class="dash-details-card-item-title"
                                                    [ngClass]="getFieldStrikethroughClass('phone.branch', versionType)">{{getFieldValueForDisplay('phone.branch',
                                                    data.phone?.branch,
                                                    versionType)
                                                    ??
                                                    '--'}}</span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <ng-container *ngIf="data.address">
                                            <div class="col-12 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <span
                                                            [innerHTML]="getFieldComparisonIcon('address.cep', versionType)"></span>
                                                        <span>CEP</span>
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title"
                                                        [ngClass]="getFieldStrikethroughClass('address.cep', versionType)">{{getFieldValueForDisplay('address.cep',
                                                        data.address?.cep,
                                                        versionType)
                                                        ?? '--'}}</span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <span
                                                            [innerHTML]="getFieldComparisonIcon('address.complement', versionType)"></span>
                                                        <span>COMPLEMENTO</span>
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title"
                                                        [ngClass]="getFieldStrikethroughClass('address.complement', versionType)">{{getFieldValueForDisplay('address.complement',
                                                        data.address?.complement,
                                                        versionType)
                                                        ?? '--'}}</span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-8">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle"
                                                        style="display: flex; align-items: center; gap: 6px;">
                                                        <span
                                                            [innerHTML]="getAddressComparisonIcon(versionType)"></span>
                                                        <span>ENDEREÇO
                                                            COMPLETO</span>
                                                    </span>

                                                    <span
                                                        class="dash-details-card-item-title"
                                                        [ngClass]="getAddressStrikethroughClass(versionType)">{{formatAddress(getAddressValueForDisplay(data.address,
                                                        versionType))}}</span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>

                            <ng-container
                                *ngTemplateOutlet="versionTemplateComparing; context: { data: getDataForView('comparing'), versionType: 'comparing' }"></ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>